import { AxiosError } from 'axios';
import { getTokenClientes } from '../Store/storages/AuthenticationStorage';
import { apiClientes } from '../config/api';
import { Response } from '../interfaces/services/Response';

export const getResultadoExameGrupo = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/ResultadoExame/GetResultadoExameGrupo', { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response.data.message;
  }
};

export const getResultadoExameByGrupo = async (codProced: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/resultadoexame/getresultadoexamebygrupo?codProced=' + codProced,
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response.data.message;
  }
};

export const getResultadoExames = async (codProced: string): Promise<string | null> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get('/resultadoExame/GetResultadoExamePdf?codProced=' + codProced,
      { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};